jQuery(document).ready(function ($) {

  var youtube = document.querySelectorAll( ".vieo-image" );
  
  for (var i = 0; i < youtube.length; i++) {
    var souce = youtube[i].dataset.video;
    var ID = getYoutubeID(souce);
    var source = "https://img.youtube.com/vi/"+ ID +"/0.jpg";
    //https://img.youtube.com/vi/bJKRhsmrsBM/0.jpg
    
    // var image = new Image();
    //         image.src = source;
    //         image.addEventListener( "load", function() {
    //             youtube[ i ].appendChild( image );
    //         }( i ) );
    
    youtube[i].addEventListener( "click", function() {
        var iframe = document.createElement( "iframe" );
        iframe.setAttribute( "frameborder", "0" );
        iframe.setAttribute( "allowfullscreen", "" );
        iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ ID +"?rel=0&showinfo=0&autoplay=1" );
        this.innerHTML = "";
        this.appendChild( iframe );
    } );    
  };
  $(".top-pdp ul li a, .overview-tabs ul li  a").click(function(e) {
    e.preventDefault();
    var ID =$(this).attr('href');
    $('html, body').animate({
        scrollTop: $(ID).offset().top - 72
    }, 100);
});   
  
  
  $(".total-stslider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".main-tabs li a").click(function (e) {
    e.preventDefault();
    var currentid = $(this).attr("href");
    $(this).parents("ul").find("li").removeClass("active");
    $(this).parent("li").addClass("active");
    $(this).parents(".stories-tab").find(".common-tab").removeClass("active");
    $(this).parents(".stories-tab").find(currentid).addClass("active");
  });
  // $(".overview-tabs li a").click(function (e) {
  //   e.preventDefault();
  //   $(window).scrollTop(0);
  //   var currentid = $(this).attr("href");
  //   $(this).parents("ul").find("li").removeClass("active");
  //   $(this).parent("li").addClass("active");
  //   $(this)
  //     .parents(".college-overview")
  //     .find(".common-tab")
  //     .removeClass("active");
  //   $(this).parents(".college-overview").find(currentid).addClass("active");
  // });
  $(".accroding-title h4").click(function (e) {
    e.preventDefault();
    $(this).parents(".single-accroding").toggleClass("active");
  });
  $(".open_popup").click(function (e) {
    e.preventDefault();
    var ppname = $(this).data("select");
    $(".popup-overlays").fadeIn();
    $("#" + ppname).fadeIn();
  });
  $(".popup-overlays, .close_button").click(function (e) {
    e.preventDefault();
    $(".popup-overlays").fadeOut();
    $(".popup-main").fadeOut();
    $("#secondary-lpopup").fadeOut();
  });
  $(".view-team").click(function (e) {
    e.preventDefault();
    var openpop = $(this).data("id");
    $(".single_popups").hide();
    $("#" + openpop).show();
    $(".popup-overlays").fadeIn();
    $("#secondary-lpopup").fadeIn();
  });
  $(".view-owners").click(function (e) {
    e.preventDefault();
    var openpop = $(this).data("id");
    $(".single_popups").hide();
    $("#" + openpop).show();
    $(".popup-overlays").fadeIn();
    $("#secondary-lpopup").fadeIn();
  });
  if ($(window).width() < 768) {
    $(".pricing-details").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
    });
    $(".all-videos").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
    });
  }

  $("#bar_image").click(function (e) {
    $(".menu_overlay_areas").fadeIn();
    $(".header-wrapper").addClass("menu-active");
    $(".header-wrapper").addClass("mobile");
  });
  $(".close_menu").click(function (e) {
    e.preventDefault();
    $(".menu_overlay_areas").fadeOut();
    $(".header-wrapper").removeClass("menu-active");
    $(".header-wrapper").removeClass("mobile");
  });
  $("summary.menu-drawer__menu-item").click(function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");
  });
});

function getYoutubeID(url){
  var i, r, rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
  r = url.match(rx);
  i = r[1];
  return i;
}
